import React from 'react';
import { useTranslation } from 'react-i18next';
import AssessmentPage from 'on_web/components/shared/AssessmentPage/AssessmentPage';
import { Grid, Typography, Box } from '@material-ui/core';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import Faq from 'on_web/components/shared/FAQ/Faq';

export default function FaqPage(props) {
  const { t } = useTranslation();
  const [isDesktop] = useCheckScreenSize();

  const getFaqItems = () => {
    const faqs = t('reporting.faq', { returnObjects: true });
    const faqItems = [];
    let keys = Object.keys(faqs);
    keys.sort(function(a, b) {
      return a.length - b.length || a.localeCompare(b);
    });
    keys.forEach(key => {
      faqItems.push({ title: faqs[key].title, content: faqs[key].paragraphs });
    });
    return faqItems;
  };

  return (
    <AssessmentPage
      headerMenuText={t('common.menu.support')}
      bottomMenuSelectedOptionCode={'faq'}
      desktopMenuIndex={9}
      secondaryHeaderWithBackNavigation={true}
    >
      <Box px={'20px'} py={'10px'} mb={'60px'}>
        <Grid container justify="center" direction="column">
          {isDesktop && (
            <Grid
              item
              xs={12}
              style={{ paddingTop: '60px', paddingBottom: '40px' }}
            >
              <Typography variant={'h2'}>{t('common.menu.support')}</Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            <Faq items={getFaqItems()} />
          </Grid>
        </Grid>
      </Box>
    </AssessmentPage>
  );
}
